import { ObjectsTable } from '@/components/objects-table';
import { Widget } from '@/components/widget';
import { useUserComponent, useUserComponents, useUserComponentss } from '@/hooks/user/use-user-components';

interface ComponentsListWidgetProps {
  id: string;
  hideable?: boolean;
}

export function ComponentsListWidget({
  id,
  hideable = false,
}: ComponentsListWidgetProps) {
  const { data } = useUserComponents();
  const components = data?.components || [];
  function handleDragData(uuid: string, label?: string) {
    return JSON.stringify({
      type: 'object/insert',
      value: [{ uuid, type: 'component', label, container: 'uicomponents' }],
    });
  }

  return (
    <Widget title="Components" id={id} hideable={hideable}>
      <ObjectsTable data={components} setDragData={handleDragData} />
    </Widget>
  );
}
